import('./stations_list.css')

export default function StationList(options){
    let container = options.container
    let flu_stations = options.station_prefixes

    let loading_element, progress_bar_element, number_element, status_element
    let list_element, title_element, table_element_container
    let stations_list = []
    initialize()

    this.generate = _ =>{
        $(container).html("")
        this.setProgress(20, 'Carregando postos pluviométricos...')
        $(container).append(loading_element, list_element)
    }

    this.loading = show =>{
        if(show){
            $(loading_element).removeClass('hide')
        } else {
            $(loading_element).addClass('hide')
            this.reloadTable()
        }
    }
    this.reloadTable = () =>{
       $(table_element_container).html("")
       generateTable()
       generateHelpLine()
    }

    this.setProgress = (value, text) =>{
        $(progress_bar_element).find('.stations-list-loading-progressbar').css({
            'width': `${value}%`
        })
        status_element.innerHTML = text
        number_element.innerHTML = `${value}%`
    }

    this.setStationsList = list =>{
        stations_list = list
    }
    
    function generateTable(){
        let table = createElement('table','stations-list-table')
        let thead = createElement('thead')
        let tbody = createElement('tbody')
        
        $(table).append(thead,tbody)

        let tr = createElement('tr')

        let th_prefix = createElement('th')
        th_prefix.innerHTML = "Pluviômetro"

        let th_last_measurement = createElement('th')
        th_last_measurement.innerHTML = "Data Última Medição"

        $(tr).append(th_prefix, th_last_measurement)

        flu_stations.forEach(station=>{
            let th_distance = createElement('th')
            th_distance.innerHTML = station.prefix
            $(tr).append(th_distance)
        })
        
        $(thead).append(tr)

        stations_list.forEach(station=>{
            function td(text){
                let el = createElement('td')
                if(parseInt(text) > 5){
                    el.innerHTML = '-'
                } else {
                    el.innerHTML = `${text.toFixed(2)} km`
                }
                return el
            }

            let tr = createElement('tr')
            
            let td_prefix = createElement('td')
            td_prefix.innerHTML = station.prefix

            let td_last = createElement('td')
            td_last.innerHTML = new Date(station.date_last_measurement).toLocaleString()

            $(tr).append(td_prefix,td_last)

            flu_stations.forEach(s=>{
                let td_distance = td(station[s.prefix])
                $(tr).append(td_distance)
            })
            
            $(tbody).append(tr)

            let _tr = new Tr({element:tr, station:station})

            station._tr = _tr
        })

        $(table_element_container).html(table)
    }

    function generateHelpLine(){
        let line = createElement('div', 'closest-list-help-line')
        line.innerHTML = "Distância para os fluviômetros"
        $(table_element_container).prepend(line)
    }

    function Tr(options){
        let element = options.element
        let station = options.station
        let selected = false
        initialize()

        this.getElement = () =>{
            return element
        }

        this.select = boolean => {
            selected = boolean
            $(this.getElement()).toggleClass('active', boolean) 
        }

        function initialize(){
            let context = this
            $(element).on('click', ()=>{
                station.select(!selected)
            })
            $(element).on('mouseover', ()=>{
                station.hover(true)
            })
            $(element).on('mouseout', ()=>{
                station.hover(false)
            })
        }
    }
    

    function initialize(){
        createLoadingElement()
        createListElement()
    }
    function createListElement(){
        list_element = createElement('div','stations-list-list-wrapper')

        let title_container = createElement('div','stations-list-title-container')
        title_element = createElement('div','stations-list-title')
        title_element.innerHTML = "PLUVIÔMETROS PRÓXIMOS"
        $(title_container).append(title_element)

        table_element_container = createElement('div', 'stations-list-table-container pretty-scrollbar')

        $(list_element).append(title_container, table_element_container)
    }

    function createLoadingElement(){
        loading_element = document.createElement('div')
        $(loading_element).addClass('stations-list-loading-wrapper')

        let loading_content = document.createElement('div')
        $(loading_content).addClass('stations-list-loading-content-wrapper')

        progress_bar_element = document.createElement('div')
        $(progress_bar_element).addClass('stations-list-loading-progressbar-container')

        let progress_bar =  document.createElement('div')
        $(progress_bar).addClass('stations-list-loading-progressbar')
    
        number_element = document.createElement('div')
        $(number_element).addClass('stations-list-loading-number')
        number_element.innerHTML = "20%"

        status_element = document.createElement('div')
        $(status_element).addClass('stations-list-loading-status')
        status_element.innerHTML = "Carregando postos pluviométricos"

        $(progress_bar_element).append(progress_bar)
        $(loading_content).append(status_element,progress_bar_element,number_element)
        $(loading_element).append(loading_content)
    }

    function createElement(type, classList){
        let el = document.createElement(type)
        if(classList){
            $(el).addClass(classList)
        }
        return el
    }
}